import moment from "moment";
import Image from "../image/image.component";
import Table from "../table/table.component";
import { CMTitleColumn, CMTracks } from "./track-list.styles";
import { useState } from "react";
import { useEffect } from "react";
import { ReactComponent as PlayIcon } from "../../icons/play-icon.svg";

  const renderImg = (props) => {
    return props.row.image_url ? <img src={props.row.image_url} width="44px" height="40px" /> : <Image src={props.row.imgSrc} width="44px" height="40px" />;
  };

  const renderTitle = (props) => {
    const { title, artist } = props.row;
    return (
      <CMTitleColumn>
        <h5>{title}</h5>
        <span>{artist}</span>
      </CMTitleColumn>
    );
  };

  const renderArtist = (props) => {
    const { title, artist } = props.row;
    return (
      <CMTitleColumn>
        <span>{artist}</span>
      </CMTitleColumn>
    );
  };

  const releaseDateColumn = (props) => {
    return <div>{moment(props.row.releaseDate).format('MMM DD, YYYY')}</div>
  }

  const playSongColumn = (props) => {
    if (props.row.mediaChannel === "video") {
      return null; 
    }
    const link = props.row.spotifyLink;
    if (!link) {
      return null;
    }
  
    return (
      <>
        <a href={link} target="_blank" rel="noopener noreferrer" style={{ margin: 'auto' }}>
          <PlayIcon width={32} height={32} />
        </a>
      </>
    );
  };
  
  const columnsDefault = [
    { field: "index", headerName: "", width: 50 },
    {
      field: "imgSrc",
      headerName: "",
      flex: 0.35,
      minWidth: 100,
      renderCell: renderImg,
    },
    {
      field: "title",
      headerName: "",
      flex: 1.25,
      minWidth: 120,
      renderCell: renderTitle,
    },
    { field: "album", headerName: "Performing Artist", flex: 1, minWidth: 150, renderCell: renderArtist },
    { field: "releaseDateStr", headerName: "Release Date", flex: 1, minWidth: 120 },
    { field: "isrc", headerName: "Song ID", flex: 1, minWidth: 100 },
    { field: "playSong", headerName: "", flex: 1, minWidth: 100, renderCell: playSongColumn },
];

const style = {
  '& .MuiDataGrid-footerContainer':{
    display: 'block'
  },
} 

const TrackList = ({tracks, artist, hiddenColumns,totaltracks, ...props}) => {
    const [rows, setRows] = useState([]);
    const [trackSize, setTrackSize] = useState(0);
    useEffect(() => {
      if (tracks) {
        let indexCounter = 1; 
    
        const tmpRows = Object.values(
          tracks.reduce((acc, track) => {
            if (track.mediaChannel === "music") {
              acc[track.id] = {
                ...track,
                index: indexCounter++ 
              };
            }
            return acc;
          }, {})
        );
    
        setRows(tmpRows);
        setTrackSize(tmpRows.length);
      }
    }, [tracks]);
    
 
    return (
        <CMTracks>
            <h3>
            Selected Track(s) {rows.length} 
            {totaltracks ? ` of ${totaltracks}` : ''}
          </h3>
            <Table
                rows={rows}
                columns={columnsDefault}
                autoHeight
                autoPageSize
                getRowHeight={() => "auto"}
                hiddenColumns={hiddenColumns || {}}
                disableSelectedRow
                hideFooterPagination={rows.length <= 5}
                {...props}
            />
        </CMTracks>
    );
}

export default TrackList;